/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function find(collection, test) {
  if (!Array.isArray(collection)) {
    return null;
  }
  if (collection.length === 0) {
    return null;
  }
  if (Array.prototype.find) {
    return collection.find(test);
  }
  if (typeof test !== 'function') {
    return null;
  }
  var needle;
  for (var i = 0, len = collection.length; i < len; i++) {
    var item = collection[i];
    if (test(item)) {
      needle = item;
      break;
    }
  }
  return needle;
}
var _default = find;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/NumericInput/src/utils/find.js
// module id = 715
// module chunks = 0